import { render, staticRenderFns } from "./particuliere-verhuizingen.vue?vue&type=template&id=6f6ea4d2"
import script from "./particuliere-verhuizingen.vue?vue&type=script&lang=js"
export * from "./particuliere-verhuizingen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports